var _path, _circle, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobilitiDc50Karacsony(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3275 25.7322H10.1029H1.89621C1.60579 25.732 1.3207 25.6585 1.06883 25.5193C0.817 25.38 0.607306 25.18 0.459675 24.9393C0.312073 24.6986 0.231389 24.4253 0.225018 24.1459C0.218648 23.8666 0.286788 23.5901 0.423205 23.3434C0.423208 23.3434 0.42321 23.3434 0.423212 23.3434L4.02768 16.8264L4.198 16.5184L3.84696 16.4936C3.56091 16.4734 3.28535 16.3822 3.04655 16.2292C2.80779 16.0762 2.61398 15.8666 2.48299 15.621C2.35203 15.3755 2.28807 15.1018 2.29681 14.826C2.30556 14.5501 2.38674 14.2807 2.5331 14.0433L2.53311 14.0433L10.5653 1.01311C10.7133 0.773461 10.923 0.574462 11.1744 0.436029C11.4259 0.297578 11.7103 0.224609 12 0.224609C12.2897 0.224609 12.5741 0.297579 12.8256 0.436029C13.077 0.574462 13.2867 0.773461 13.4347 1.01311L21.4669 14.0433L21.4669 14.0433C21.6133 14.2807 21.6944 14.5501 21.7032 14.826C21.7119 15.1018 21.648 15.3755 21.517 15.621C21.386 15.8666 21.1922 16.0762 20.9534 16.2292C20.7147 16.3822 20.4391 16.4734 20.153 16.4936L19.802 16.5184L19.9723 16.8264L23.5768 23.3434C23.5768 23.3434 23.5768 23.3434 23.5768 23.3434C23.7132 23.5901 23.7814 23.8666 23.775 24.1459C23.7686 24.4253 23.6879 24.6986 23.5403 24.9393C23.3927 25.18 23.183 25.38 22.9312 25.5193C22.6793 25.6585 22.3942 25.732 22.1038 25.7322H13.8971H13.6725V25.9568V29.7754H10.3275V25.9568V25.7322Z",
    fill: "#FFC20E",
    stroke: "#408E8D",
    strokeWidth: 0.449219
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 15,
    r: 6,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.161 13.8086L14.5983 18.1528L14.9624 16.31L16.6824 15.6799L12.161 13.8086Z",
    fill: "#408E8D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5111 15.6802H7.63636L9.00467 16.9261L8.67455 18.7737L12.5111 15.6802Z",
    fill: "#ABE1FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8457 15.0561L13.2831 10.7135L11.5507 11.3103L10.1608 10.0913L10.8457 15.0561Z",
    fill: "#FFC20E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilitiDc50Karacsony);
export default __webpack_public_path__ + "static/media/mobiliti_dc50_karacsony.a11db96fbc3149825486628027430b10.svg";
export { ForwardRef as ReactComponent };